module.exports = __webpack_public_path__ + "static/media/PL.ed9d5529.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/PL.svg
// module id = 2240
// module chunks = 7